// extracted by css-extract-rspack-plugin
export default {"Box":"suggested-item-option-module__Box__toFr6","Box_1":"suggested-item-option-module__Box_1__Gl8HM","Text":"suggested-item-option-module__Text__Gz0Sy"};